<style lang="scss">

</style>

<template>
  <section class="text-center">
    <h3>{{ $t('contacts.block_confirmation', { firstname: contact.firstname, lastname: contact.lastname }) }}</h3>

    <section class="mt-2">
      <b-form-textarea v-model="reason" :placeholder="$t('contacts.reason_placeholder')" max-rows="3" />
    </section>

    <section class="d-inline-flex full-width mt-2">
      <div class="ui-spacer" />
      <b-button class="mr-2" @click="$emit('close', true)">{{ $t('common.cancel') }}</b-button>
      <b-button :class="{'disabled': loading}" variant="success" @click="blockContact()">{{ $t('contacts.block_button') }}</b-button>
    </section>
  </section>
</template>
<script>
import ContactService from '@/services/ContactService'

export default {
  components: {},
  props: {
    contact: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      reason: '',
      loading: false,
    }
  },
  mounted() {},
  methods: {
    blockContact() {
      this.loading = true;
      ContactService.blockContact(this.contact.user_id, this.reason).then(() => {
        this.$toast.success(
          this.$t('contacts.success.block', { firstname: this.contact.firstname, lastname: this.contact.lastname }),
          { toastClassName: ['toast-std', 'success-toast'] },
        );
      }).catch(() => {
        this.$toast.error(this.$t('contacts.error.block'), {
          toastClassName: ['toast-std', 'warning-toast'],
        });
      }).finally(() => {
        this.loading = false;
        this.$emit('ok', true);
      })
    },
  },
}
</script>
